/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { dateToFormat, formatDateHour, formatFullDateTime } from "../../utils/date";
import SVG from "react-inlinesvg";
import calendarIcon from "../../assets/images/icon/calendar.svg";
import { get } from "lodash-es";
import { classnames } from "../../utils/text";
import { isArray, isEqual } from "lodash";
import { FLATPICKR_DATE_LOCALE } from "../../constants/DAY";
import { isEmpty } from "../../utils/lodashExtend";

const getCustomDisplayLabel = (dates) => {
  let label = <span className="empty-date">날짜선택</span>;
  if (!isEmpty(dates)) {
    label = dates[0];
    if (dates[1]) {
      label += ` ~ ${dates[1]}`;
    }
  }
  return label;
};

const CustomDisplay = ({
  dates = [],
  inputRef,
  className,
  labelClassName = "",
  disabled,
  dataenabletime,
  ...props
}) => {
  return (
    <div className={classnames("datepicker-wrap", className)}>
      {disabled && <div className="disabled-wrap" />}
      <label ref={inputRef} {...props}>
        <span className="icon" data-toggle>
          <SVG src={calendarIcon} />
        </span>
        <span className={classnames("datepicker-label", labelClassName)}>
          {getCustomDisplayLabel(dates)}
        </span>
        <input className="datepicker-input" defaultValue={dates} />
      </label>
    </div>
  );
};

const DatePicker = (_props) => {
  const { defaultValue, form, field, onChange, disabled, ...props } = _props;

  const [dates, setDates] = useState([]);
  const [_dates, _setDates] = useState([]); // display 용

  const _dateToFormat = (date) => {
    return dateToFormat(date, props['data-enable-time'] ? formatDateHour : undefined);
  };
  useEffect(() => {
    if (defaultValue) {
      setDates(defaultValue);
      _setDates(defaultValue);
    }
  }, [defaultValue]);

  const handleOnChange = (__dates, key = get(field, "key", "datepicker")) => {
    if (__dates && isArray(__dates)) {
      if (__dates[0] !== _dates[0] || __dates[1] !== _dates[1]) {
        const _customDate = {
          [key]: __dates,
        };
        _setDates(__dates);
        if (onChange) {
          onChange(_customDate);
        }
      }
    }
  };

  useEffect(() => {
    const __dates = [];
    if (dates && isArray(dates)) {
      dates.forEach((d) => {
        __dates.push(_dateToFormat(d));
      });
      handleOnChange(__dates);
    } else if (dates) {
      handleOnChange([_dateToFormat(dates)]);
    }


  }, [dates]);

  useEffect(() => {
    if (form && field && field.key && !isEmpty(get(form, `${[field.key]}`)) && !isEqual(get(form, `${[field.key]}`), dates)) {
      if (isArray(get(form, `${[field.key]}`))) {
        setDates(get(form, `${[field.key]}`).map(item => dateToFormat(item, formatFullDateTime)));
      } else {
        setDates(dateToFormat(get(form, `${[field.key]}`), formatFullDateTime));
      }
    }

  }, [form]);

  return (
    <Flatpickr
      Data-enable-time
      render={(prop, ref) => {
        return (
          <CustomDisplay
            dataEnableTime
            dates={_dates}
            inputRef={ref}
            className={get(field, "className")}
            disabled={disabled}
            {...props}
          />
        );
      }}
      defaultValue={[]}
      onChange={setDates}
      {...field}
      {...props}
      options={
        {
          locale: FLATPICKR_DATE_LOCALE,
          ...(props && props.options ? props.options : {}),
          ...(field && field.options ? field.options : {}),
        }
      }
    />
  );
};

export default DatePicker;
